import { useAuth0 } from "@auth0/auth0-react";
import { getAuth0RedirectUri } from "../lib/auth0-redirect";
import { rememberNavForAfterAuthRedirect } from "../lib/postLoginNav";

type Props = {
  onContinueGuest: () => void;
};

export function WelcomeGate({ onContinueGuest }: Props) {
  const auth0 = useAuth0();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-surface-0/95 p-6 pt-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.5rem,env(safe-area-inset-bottom))] pl-[max(1.5rem,env(safe-area-inset-left))] pr-[max(1.5rem,env(safe-area-inset-right))] backdrop-blur-md"
      role="dialog"
      aria-modal="true"
      aria-labelledby="welcome-title"
      aria-describedby="welcome-desc"
    >
      <div className="max-h-[min(90dvh,calc(100dvh-env(safe-area-inset-top)-env(safe-area-inset-bottom)-3rem))] w-full max-w-md overflow-y-auto overscroll-contain rounded-2xl border border-border bg-surface-1 p-6 shadow-xl shadow-black/20 sm:p-8">
        <p className="font-display text-2xl font-bold tracking-tight text-text" id="welcome-title">
          Welcome to Dripwatch
        </p>
        <p className="mt-3 text-sm leading-relaxed text-text-muted" id="welcome-desc">
          Sign in to sync your subscriptions across devices, or continue in this browser without an
          account. Guest data stays on this device until you sign in.
        </p>
        <div className="mt-8 flex flex-col gap-3">
          <button
            type="button"
            onClick={() => {
              rememberNavForAfterAuthRedirect("dashboard");
              void auth0.loginWithRedirect({
                authorizationParams: { redirect_uri: getAuth0RedirectUri() },
              });
            }}
            className="min-h-12 w-full touch-manipulation rounded-xl bg-accent px-4 py-3 text-base font-semibold text-surface-0 shadow-lg shadow-accent/25 hover:brightness-110 sm:text-sm"
          >
            Sign in
          </button>
          <button
            type="button"
            onClick={() => {
              rememberNavForAfterAuthRedirect("dashboard");
              void auth0.loginWithRedirect({
                authorizationParams: {
                  redirect_uri: getAuth0RedirectUri(),
                  connection: "google-oauth2",
                },
              });
            }}
            className="min-h-12 w-full touch-manipulation rounded-xl border border-border bg-surface-2 px-4 py-3 text-base font-semibold text-text hover:bg-surface-0/30 sm:text-sm"
          >
            Continue with Google
          </button>
          <button
            type="button"
            onClick={onContinueGuest}
            className="min-h-12 w-full touch-manipulation rounded-xl border border-border border-dashed px-4 py-3 text-base font-medium text-text-muted hover:border-border hover:bg-surface-2 hover:text-text sm:text-sm"
          >
            Continue as guest
          </button>
        </div>
      </div>
    </div>
  );
}
